import { createCommand } from '@atlassian/rovo-content-bridge-api';
/**
 * A command sent by the rovo client to send the trace message to the inline input box.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to trace the ongoing message.
 */
export var InlineInputBoxTraceMessageCommand = createCommand('inline-input-box-trace-message-command');